type UnitOfMeasureObject = {
  label?: unknown;
  name?: unknown;
};

export function formatUnitOfMeasure(unit: unknown): string {
  if (typeof unit === "string" || typeof unit === "number") {
    return String(unit);
  }

  if (unit && typeof unit === "object") {
    const { label, name } = unit as UnitOfMeasureObject;
    if (typeof label === "string") return label;
    if (typeof name === "string") return name;
  }

  return "";
}
